import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import TitlePage from "./../../../common/TitlePage";
import {Box} from "@material-ui/core";
import {convertNumberToPersian} from "../../../method/convertDigitToEnglish";

const useStyles = makeStyles((theme) => ({
    container: {
        position: "relative",
        overflow: "hidden",
        marginTop: 90,
    },
    root: {
        width: "60%",
        margin: "0 auto",
        textAlign: "center",
        paddingBottom: 100,
        [theme.breakpoints.down("680")]: {
            width: "95%",
            flexDirection: "wrap",
            paddingBottom: 60,
        },
    },
    content: {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "auto auto auto auto auto",
        justifyContent: "center",
        marginTop: 60,
        flexWrap: "wrap",
        [theme.breakpoints.down("1450")]: {
            marginTop: 20,
            gridTemplateColumns: "auto auto auto ",
        },
        // [theme.breakpoints.down("1000")]: {
        //   marginTop: 20,
        //   gridTemplateColumns: "auto auto",
        //   gridGap: "20px 50px",
        // },
        [theme.breakpoints.down("708")]: {
            marginTop: 20,
            gridTemplateColumns: "auto",
            gridGap: "5px 5px",
        },
        "& p": {
            fontSize: 15,
            color: "black",
            width: '85%',
            margin: '0 auto',
        },
        "& img": {
            height: 80,
        },
        "& button": {
            border: `1px solid ${theme.palette.light.type2}`,
            borderRadius: 18,
            color: theme.palette.light.type2,
            padding: "7px 18px",
            [theme.breakpoints.down("680")]: {
                padding: "7px 13px",
            },
        },
    },
    box: {
        margin: "10px 10px",
        width: "187px",
        height: "270px",
        // background: "#ffffff",
        background: "#f2f4f6",
        borderRadius: "10px",
        // boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.16)",
        [theme.breakpoints.down("600")]: {
            width: "160px",
        },
        [theme.breakpoints.down("450")]: {
            width: "148px",
            margin: "3px 3px",
        },
    },
    color: {
        color: theme.palette.light.type2
    },
    arrowBox: {
        [theme.breakpoints.down("708")]: {
            display: 'block',
            transform: "rotate(90deg)"
        },
    },
    parentArrow: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down("708")]: {
            flexDirection: "column",
            justifyContent: "rotate(90deg)"
        },
    }
}));

export default function SystemTrades() {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.root}>
                <TitlePage position="bottomCenter">
                    مراحل ثبت سفارش خودرو در کارگزاری
                    {` `}
                    <span className={classes.color}>پویان</span>
                </TitlePage>

                <Box className={classes.content}>
                    {data.map((item, ind) => (
                        <div className={`align-items-center ${classes.parentArrow}`}>
                            <Box key={ind} className={classes.box}>
                                <a href={item.src2} target="_blank">
                                    <img
                                        src={`/assets/images/${item.src}`}
                                        alt={item.title}
                                        className="mt-3"
                                    />
                                    <p className="mt-3 mb-4">
                                        {convertNumberToPersian(item.title)}
                                    </p>
                                </a>
                            </Box>
                            {
                                ind !== data.length - 1 && (
                                    <img
                                        src={`/assets/images/arrowLeft.png`}
                                        alt={item.title}
                                        style={{height: 35}}
                                        className={classes['arrowBox']}
                                    />
                                )
                            }
                        </div>
                    ))}
                </Box>
            </div>
        </div>
    );
}

let data = [
    {
        title: "ثبت نام در سامانه سجام",
        src: "car1.png",
    },
    {
        title: "دریافت آنلاین کد معاملاتی بازار فیزیکی بورس کالا از کارگزاری پویان به آدرس Pouyan.ebgo.ir",
        src: "car2.png",
    },
    {
        title: "افتتاح حساب وکالتی بورس کالا و معرفی آن به کارگزاری پویان",
        src: "car3.png",
    },
    {
        title: "واریز مبلغ قیمت پایه اعلام شده مطابق اطلاعیه عرضه خودرو به حساب وکالتی یک روز قبل از عرضه و هماهنگی با کارگزاری",
        src: "car4.png",
    },
    {
        title: "ثبت سفارش خرید از طریق کارگزاری پویان یک روز قبل از عرضه",
        src: "car5.png",
    },

];
